import { Col, Row } from "antd";
import React from "react";
import { formatTextCurrency } from "../../../utils/helpers";
import { CartPlusIcon } from "../../assets/icons.constants";
import DisplayImageComponent from "../display-image/DisplayImageComponent";
import "./ProductCartComponent.scss";

function ProductCartComponent(props) {
  const { data, onClickButtonAdd, onClickTitle, isOutOfStock = false, isGridView } = props;

  function handleOnClickButtonAdd() {
    if (onClickButtonAdd) {
      onClickButtonAdd();
    }
  }

  function handleOnClickTitle() {
    if (onClickTitle) {
      onClickTitle();
    }
  }

  return (
    <div
      className={`product-cart  ${isOutOfStock ? "product-cart-out-of-stock" : ""} ${
        !isGridView ? "qr-order-product-card-theme1-list-view" : ""
      }`}
    >
      <DisplayImageComponent
        className="product-cart-image cursor-pointer"
        promotionTag={data?.promotionTag}
        src={data?.thumbnail}
        onClick={handleOnClickTitle}
        isOutOfStock={isOutOfStock}
      />
      <Row className="content">
        <Col span={24} className="title cursor-pointer" onClick={handleOnClickTitle}>
          {data?.name}
        </Col>
        <Col span={12} className="price">
          <div className="selling-price">{formatTextCurrency(data?.sellingPrice)}</div>
          {data?.originalPrice > data?.sellingPrice && (
            <div className="original-price">{formatTextCurrency(data?.originalPrice)}</div>
          )}
        </Col>
        <Col span={12} className="button" onClick={handleOnClickButtonAdd}>
          <CartPlusIcon className="cursor-pointer" />
        </Col>
      </Row>
    </div>
  );
}

export default React.memo(ProductCartComponent, (prevProps, nextProps) => prevProps.data === nextProps.data);
